import React, { useContext } from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import { CurrencyContext } from "../../../context/Context";

// Monto en la moneda base del condominio.
const Money = ({ value, className }) => {
  const { baseCurrency } = useContext(CurrencyContext);

  return (
    <NumberFormat
      className={className}
      value={Number(value || 0)}
      prefix={`${baseCurrency?.symbol || "$"} `}
      thousandSeparator
      decimalScale={2}
      fixedDecimalScale
      displayType="text"
    />
  );
};

Money.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

// El mismo monto en la moneda de la tasa de cambio activa. No muestra nada
// cuando la tasa es 1 (el condominio no trabaja con dos monedas).
export const ConvertedMoney = ({ value, converted, className }) => {
  const { currency: curr } = useContext(CurrencyContext);
  const rate = Number(curr?.value || 1);

  if (!curr?.currency?.iso || rate === 1) return null;

  const amount = converted ?? Number(value || 0) * rate;

  return (
    <NumberFormat
      className={className}
      value={Number(amount || 0)}
      prefix={`${curr.currency.iso} `}
      thousandSeparator
      decimalScale={2}
      fixedDecimalScale
      displayType="text"
    />
  );
};

ConvertedMoney.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  converted: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default Money;
